import axios from 'axios';

const ACCESS_KEY_STORAGE = 'newsflash_ai_access_key';

const api = axios.create({
  baseURL: process.env.VUE_APP_API,
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json',
  },
});

function getAccessKey() {
  return window.sessionStorage.getItem(ACCESS_KEY_STORAGE) || '';
}

function storeAccessKey(key) {
  if (key) {
    window.sessionStorage.setItem(ACCESS_KEY_STORAGE, key);
  }
}

function clearAccessKey() {
  window.sessionStorage.removeItem(ACCESS_KEY_STORAGE);
}

function withAccessKey(config = {}) {
  const key = getAccessKey();
  if (!key) {
    return config;
  }

  return {
    ...config,
    params: {
      ...(config.params || {}),
      k: key,
    },
  };
}

export default {
  getAccessKey,
  storeAccessKey,
  clearAccessKey,

  listQueue() {
    return api.get('/api/newsflash-ai/queue', withAccessKey());
  },

  getQueueItem(id) {
    return api.get(`/api/newsflash-ai/queue/${encodeURIComponent(id)}`, withAccessKey());
  },

  sendToJa(id) {
    return api.post(`/api/newsflash-ai/queue/${encodeURIComponent(id)}/send-ja`, {}, withAccessKey());
  },

  discard(id) {
    return api.post(`/api/newsflash-ai/queue/${encodeURIComponent(id)}/discard`, {}, withAccessKey());
  },

  getJaItem(id) {
    return api.get(`/api/newsflash-ai/ja/${encodeURIComponent(id)}`, withAccessKey());
  },

  approveJa(id) {
    return api.post(`/api/newsflash-ai/ja/${encodeURIComponent(id)}/approve`, {}, withAccessKey());
  },

  rejectJa(id) {
    return api.post(`/api/newsflash-ai/ja/${encodeURIComponent(id)}/reject`, {}, withAccessKey());
  },

  runCapture() {
    return api.post('/api/newsflash-ai/run', {}, withAccessKey());
  },
};
